import { monitoringService } from "Apis";

export const sendEvent = (projectId: number, event: string, data: string) => {

  monitoringService.monitoringServiceTrack({
    projectId,
    eventName: event,
    payload: {
      data,
    },
  }).catch((error) => {
    console.error("Error sending event to monitoring", error);
  });

}